<section class="hero">
  <div class="container-fluid px-0 h-100">
    <div class="row g-0 h-100 align-items-center">

      <div class="col-12 col-lg-6 hero__content p-4 p-lg-5">

        <span class="hero__badge hero__animate hero__animate--1 rounded-pill mb-3">Protecting pets since 1989</span>

        <h1 class="hero__headline hero__animate hero__animate--2 display-2 mb-3">
          Helping lost pets get home.
        </h1>

        <p class="hero__body hero__animate hero__animate--3 mb-3">
          When pet adventures don't go to plan, we're there to bring families back together.
        </p>

        <div class="hero__animate hero__animate--4 d-flex flex-column flex-sm-row gap-3">
          <a routerLink="/login-register" class="btn ui-btn ui-btn--primary fw-bold">Register my pet now</a>
          <a [routerLink]="[]" fragment="steps-to-a-safer-pet" class="btn ui-btn ui-btn--outline-light fw-bold">See how it works</a>
        </div>

      </div>

      <div class="col-12 col-lg-6 hero__image-col">
        <div class="hero__image-wrapper">
          <img
            src="/assets/images/home/woman-with-cat.webp"
            srcset="/assets/images/home/woman-with-cat-800.webp 800w, /assets/images/home/woman-with-cat.webp 1000w"
            sizes="(min-width: 992px) 50vw, 100vw"
            width="1000"
            height="1000"
            fetchpriority="high"
            alt="Person with pet"
            class="hero__image">
        </div>
      </div>

    </div>
  </div>
</section>
